import { GlobalContext, GlobalContextValue } from "@lib/context/global/context";
import { useContext } from "react";

const useGlobalContext = () => {
  return useContext<GlobalContextValue>(GlobalContext);
};

export default useGlobalContext;
